module.exports = __webpack_public_path__ + "static/img/13.342830f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/zh/13.png
// module id = 50yu
// module chunks = 0